import TodaysParkingCard from "../../../components/Reports/VisitorReport"

const VisitorReportPage = () => {
    return <TodaysParkingCard/>
}

export default VisitorReportPage;